"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.function.name");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.createItem = createItem;
exports.isAvailable = isAvailable;
exports.isDisplayed = isDisplayed;
exports.getRelFqn = getRelFqn;
exports.BmItemInfo = void 0;

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _itemRegistry = require("../../../registry/item-registry");

var _rules = require("../../../rules");

var _renderLayout = require("../../layouts/render-layout");

var BmItemInfo = function BmItemInfo(item, parent) {
  var _context,
      _context2,
      _this = this;

  (0, _classCallCheck2.default)(this, BmItemInfo);
  this.mixins = {};
  this.name = void 0;
  this.parent = void 0;
  this.fullyResolvedName = void 0;
  this.root = void 0;
  this.available = void 0;
  this.rendered = false;
  this.disabled = void 0;

  if ((0, _includes.default)(_context = item.name).call(_context, '.')) {
    console.error("Invalid item name \"".concat(item.name, "\": must not have any '.' chars"));
  }

  this.name = item.name;
  this.parent = parent;
  this.root = this.parent ? this.parent.root : this;
  this.fullyResolvedName = this.parent ? (0, _concat.default)(_context2 = "".concat(this.parent.fullyResolvedName, ".")).call(_context2, this.name) : this.name;

  if (this.parent) {
    this.root.dependencyMap.addDependencies(this.fullyResolvedName, item);

    this.root.dependencyMap._addDependency(this.fullyResolvedName, 'rendered', {
      type: _rules.Operator.transform,
      op1: {
        type: _rules.OperandType.resolved,
        fieldIdentifier: 'parent',
        propPath: 'layout'
      },
      cb: function cb(layout) {
        return layout && new _set.default((0, _renderLayout.getLayoutDependents)(layout)).has(_this.name);
      }
    });
  } else {
    this.rendered = true;
  }
};

exports.BmItemInfo = BmItemInfo;

function createItem(item, parent, layout, values) {
  var engine = (0, _itemRegistry.getItem)(item.type);
  return engine.factory(item, parent, layout, values);
}

function isAvailable(info) {
  var available = info.available !== false;
  return available;
}

function isDisplayed(info) {
  return isAvailable(info) && info.rendered;
}

function getRelFqn(item) {
  var ancestorFqn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var fqn = item.fullyResolvedName;
  if (!ancestorFqn) return fqn;
  var relativeStart = (0, _indexOf.default)(fqn).call(fqn, ancestorFqn) + ancestorFqn.length + 1;
  var relativeFqn = (0, _slice.default)(fqn).call(fqn, relativeStart);
  return relativeFqn;
}
